import { CLUB_MANAGEMENT_MEMBER_MEMBERSHIP_ROUTER, CLUB_MANAGEMENT_MEMBERSHIP_ROUTER } from "@Router/routerPath";
import { ClubManagementMembershipPage } from "@Local/ClubManagement";
import ClubManagementMemberMembershipPage from "@Local/ClubManagement/ClubManagementMemberMembershipItemPage";
import { FRONT_KEY } from "@Constants/frontKey";

const clubManagementRouter = [
	{
		description: "店鋪管理",
		frontKey: FRONT_KEY.CLUB_MANAGEMENT,
	},
	{
		description: "會員會籍搜尋頁",
		frontKey: FRONT_KEY.CLUB_MANAGEMENT_MEMBERSHIP_SEARCH,
		static: true,
		exact: true,
		path: CLUB_MANAGEMENT_MEMBER_MEMBERSHIP_ROUTER,
		href: CLUB_MANAGEMENT_MEMBER_MEMBERSHIP_ROUTER,
		as: ClubManagementMembershipPage,
	},
	{
		description: "會員會籍頁",
		frontKey: FRONT_KEY.CLUB_MANAGEMENT_MEMBERSHIP,
		static: true,
		path: CLUB_MANAGEMENT_MEMBERSHIP_ROUTER,
		href: CLUB_MANAGEMENT_MEMBERSHIP_ROUTER,
		as: ClubManagementMemberMembershipPage,
	},
];

export default clubManagementRouter;
